<div class="relative mt-8 flex flex-auto flex-col items-center gap-8">
  @if (plan(); as p) {
    <div class="w-full max-w-3xl">
      <!-- Summary Card -->
      <div class="surface-default flex flex-col gap-4 rounded-xl border border-gray-5 p-6 shadow-sm">
        <div class="flex items-center justify-between">
          <div class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wider text-gray-9">Offre / Plan</span>
            <h1 class="text-2xl font-bold text-gray-12">
              {{ p.name }}
            </h1>
          </div>
          <div
            class="inline-flex items-center gap-x-1.5 rounded-md bg-neutral-a4 px-2.5 py-1 text-sm font-medium"
          >
            <div
              class="size-2 rounded-full"
              [class.bg-green-9]="p.isActive"
              [class.bg-red-9]="!p.isActive"
            ></div>
            {{ p.isActive ? 'Actif' : 'Inactif' }}
          </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Details Grid -->
        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
          <!-- Left side: Pricing and Billing Cycle -->
          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-1">
              <span class="text-xs font-semibold uppercase tracking-wider text-gray-9">Tarif</span>
              <div class="text-lg font-semibold text-gray-12">
                {{ p.price | priceDisplay: p.currency }}
              </div>
            </div>

            <div class="flex flex-col gap-1">
              <span class="text-xs font-semibold uppercase tracking-wider text-gray-9"
                >Cycle de facturation</span
              >
              <div class="text-sm text-gray-12">
                @if (p.billingCycle === 'monthly') {
                  Mensuel
                } @else if (p.billingCycle === 'quarterly') {
                  Trimestriel
                } @else if (p.billingCycle === 'yearly') {
                  Annuel
                } @else {
                  {{ p.billingCycle }}
                }
              </div>
            </div>
          </div>

          <!-- Right side: Features -->
          <div class="flex flex-col gap-2">
            <span class="text-xs font-semibold uppercase tracking-wider text-gray-9"
              >Fonctionnalités incluses</span
            >
            @if (p.features.length) {
              <ul class="flex flex-col gap-1.5">
                @for (feat of p.features; track feat) {
                  <li class="flex items-start text-sm text-gray-12">
                    <mat-icon class="mr-2 text-green-9 text-base w-4 h-4 min-w-4 min-h-4"
                      >check_circle</mat-icon
                    >
                    <span>{{ feat }}</span>
                  </li>
                }
              </ul>
            } @else {
              <div class="text-sm text-gray-9 italic">Aucune fonctionnalité spécifiée</div>
            }
          </div>
        </div>

        @if (p.metadata.stripe; as stripe) {
          <mat-divider></mat-divider>

          <!-- Stripe Info -->
          <div class="flex flex-col gap-4">
            <span class="text-xs font-semibold uppercase tracking-wider text-gray-9"
              >Configuration Stripe</span
            >
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
              @if (stripe.productId) {
                <div class="flex flex-col gap-1">
                  <span class="text-xs text-gray-10">ID de Produit Stripe (Product ID)</span>
                  <span class="font-mono text-sm text-gray-12 select-all">{{ stripe.productId }}</span>
                </div>
              }
              @if (stripe.priceId) {
                <div class="flex flex-col gap-1">
                  <span class="text-xs text-gray-10">ID de Prix Stripe (Price ID)</span>
                  <span class="font-mono text-sm text-gray-12 select-all">{{ stripe.priceId }}</span>
                </div>
              }
            </div>
          </div>
        }

        <mat-divider></mat-divider>

        <!-- Metadata / Timeline -->
        <div class="flex flex-col gap-2 md:flex-row md:justify-between text-xs text-gray-9">
          <div>Créé le : {{ p.createdAt | luxonDate: 'dd/LL/yyyy HH:mm' }}</div>
          <div>Mis à jour le : {{ p.updatedAt | luxonDate: 'dd/LL/yyyy HH:mm' }}</div>
        </div>
      </div>
    </div>
  }
</div>
